module.exports = __webpack_public_path__ + "img/frame (222).1e489ade.jpg";